import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-topbar',
  imports: [FormsModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  @Input({ required: true }) currentAccessTitle = '';
  @Input({ required: true }) currentAccessSubtitle = '';
  @Input({ required: true }) profileThumbnailPath = '';
  @Input() isPublicAccess = true;
  @Input() mobileMenuVisible = false;
  @Input() cadastralReferenceSearch = '';

  @Output() mobileMenuOpened = new EventEmitter<void>();
  @Output() profileSelectionOpened = new EventEmitter<Event>();
  @Output() cadastralReferenceSearchChange = new EventEmitter<string>();
  @Output() cadastralReferenceSearchScheduled = new EventEmitter<void>();

  protected updateCadastralReferenceSearch(value: string): void {
    this.cadastralReferenceSearch = value;
    this.cadastralReferenceSearchChange.emit(value);
    this.cadastralReferenceSearchScheduled.emit();
  }
}
